import React, { createRef, useEffect, useRef } from 'react';

import { ScrollToPlugin } from 'gsap/all';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap/gsap-core';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

export const EslStatistic = ({ icon, value, label, description }) => {
    const container = createRef();

    useEffect(() => {
        //Intro animation
        const el = container.current;
        gsap.set(el.parentNode, { perspective: 1500 });
        const offset = el.getBoundingClientRect().left > window.innerWidth / 2 - 20 ? 200 : -200;
        gsap.from(el, {
            scrollTrigger: {
                trigger: el,
                start: 'top bottom-=70px',
                end: '+=50',
                scrub: 1,
                once: true,
            },
            // x: offset,
            duration: 0.4,
            opacity: 0,
            // rotationX: 90,
            y: 30,
            // ease: 'back.out(1.5)',
        });
    }, []);

    return (
        <div className="esl-stat" ref={container}>
            <div className="esl-stat__inner" tabIndex="0">
                <div className="esl-stat__icon">{icon}</div>
                <div className="esl-stat__value">{value}</div>
                <div className="esl-stat__label">{label}</div>
                <div className="esl-stat__description">{description}</div>
            </div>
        </div>
    );
};
